import React from "react";
import CardTemplate from "./CardTemplate";
import styled from "styled-components";
import { OnlineShoppingData } from "hooks/ConsultantDashboard/useConsultantDashboardData";

interface Props {
	onlineShoppingData: OnlineShoppingData;
}

const OnlineShopping = ({ onlineShoppingData }: Props) => {
	const replaceDashesWithSlashes = (str: string) => {
		return str.replace(/-/g, "/");
	};

	return (
		<CardTemplate
			title="Online Shopping"
			linkText={onlineShoppingData.enabled ? "Enabled" : "Disabled"}
		>
			<Container>
				<LeftContainer>
					<StyledText>Sales</StyledText>
					<LargeText>${onlineShoppingData.sales}</LargeText>
				</LeftContainer>
				<RightContainer>
					<BoldText>Date:</BoldText>
					<Date>
						{replaceDashesWithSlashes(onlineShoppingData.startDate)}{" "}
						- {replaceDashesWithSlashes(onlineShoppingData.endDate)}
					</Date>
				</RightContainer>
			</Container>
		</CardTemplate>
	);
};

const Container = styled.div`
	display: flex;
	justify-content: left;
	flex-wrap: wrap;
	column-gap: 150px;
	row-gap: 16px;
`;

const LeftContainer = styled.div`
	display: flex;
	gap: 4px;
	flex-direction: column;
	justify-content: left;
	margin-bottom: 16px;
`;

const RightContainer = styled(LeftContainer)`
	display: flex;
	gap: 4px;
	flex-direction: column;
	justify-content: left;
	margin-bottom: 0px;
`;

const LargeText = styled.div`
	font-weight: 900;
	font-size: 36px;
	line-height: 36px;
`;

const StyledText = styled.div`
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: 19px;
`;

const Date = styled.div`
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 19px;
`;

const BoldText = styled.div`
	font-weight: 700;
	display: inline;
`;

export default OnlineShopping;
